import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';

export default class AuthenticatedRepayingStudentDebtRepaymentStrategyFinderQuestionnaireController extends Controller {
  // Testing aid: ?direct=true / ?ffel=true / ?plus=true inject a blank, editable
  // card for that loan type when the user has none of it (see withTestLoanCards).
  @tracked direct = '';
  @tracked ffel = '';
  @tracked plus = '';

  queryParams = ['direct', 'ffel', 'plus'];
}
